// src/lib/remoteOptions/index.ts
import { carsOptions } from './cars';
import { clientsOptions } from './clients';
import { quotationsOptions } from './quotations';
import { activitiesOptions } from './activities';
import { opportunitiesOptions } from './opportunities';
import { salesOptions } from './sales';
import { expensesOptions } from './expenses';
import { collectionsOptions } from './collections';
import { influencersOptions } from './influencers';
import { leadsOptions } from './leads';
import { productsOptions } from './products';
import { postersOptions } from './posters';
import { contactsOptions } from './contacts';
import { usersOptions } from './users'
import { catalogsOptions } from './catalogs'
import { fiscalOptions } from './fiscal'

export const remoteOptionsRegistry: Record<string, (query?: string | Record<string, any>) => Promise<any[]>> = {
  ...carsOptions,
  ...clientsOptions,
  ...quotationsOptions,
  ...activitiesOptions,
  ...opportunitiesOptions,
  ...salesOptions,
  ...expensesOptions,
  ...collectionsOptions,
  ...influencersOptions,
  ...leadsOptions,
  ...productsOptions,
  ...postersOptions,
  ...contactsOptions,
  ...usersOptions,
  ...catalogsOptions,
  ...fiscalOptions
};
